import { Component, ElementRef, HostListener, OnInit, ViewChild } from '@angular/core';
import { AnimationService } from 'src/app/utils/animation.service';

@Component({
  selector: 'app-jalasoft-foundation',
  templateUrl: './jalasoft-foundation.component.html',
  styleUrls: ['../home.component.scss', './jalasoft-foundation.component.scss']
})
export class JalasoftFoundationComponent implements OnInit {
  
  @ViewChild('animation')
  animation: ElementRef;

  constructor(private animations: AnimationService) { }

  ngOnInit(): void {
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event) {
    this.animations.startRightToLeftAnimation(this.animation.nativeElement);
  }
}
